// Optimistic "fake progress" curve for indeterminate loaders (image / video / tweak
// generation). The bar can't reflect real backend progress, so it's estimated from
// elapsed time.
//
// A saturating exponential rather than a linear ramp that stops: it reaches ~90% at
// `expectedDurationSec` (matching the prior linear target, so tuned durations still
// feel the same) and then keeps creeping toward 100% asymptotically — slowing as it
// goes — without ever getting there. The bar only truly "completes" when the real
// result lands and the placeholder is replaced, so it must never sit at 100% on its
// own; FAKE_PROGRESS_CEILING keeps it a hair short even on very long waits.
export const FAKE_PROGRESS_CEILING = 99

// e^(-k) = 0.1  ⇒  pct = 90% exactly at t = expectedDuration.
const SATURATION_K = Math.log(10)

// Base estimate for a given elapsed time (no jitter). Monotonically increasing in
// `elapsedSec`, so callers can safely ratchet it with Math.max(prev, ...).
export function fakeProgressPct(elapsedSec, expectedDurationSec) {
  if (!(expectedDurationSec > 0) || !(elapsedSec > 0)) return 0
  const pct =
    100 * (1 - Math.exp((-SATURATION_K * elapsedSec) / expectedDurationSec))
  return Math.min(pct, FAKE_PROGRESS_CEILING)
}
